import { combineReducers } from "redux";

import account from "./AccountReducer";

export default combineReducers({
  account
});
